<template>
  <b-card>
    <b-card-header>
      <h2>Cortex Plus Resources</h2>
    </b-card-header>
    <b-card-body>
      <div>{{msg}}</div>
      <cortex-plus-character-sheet></cortex-plus-character-sheet>
    </b-card-body>
  </b-card>
</template>

<script>
import CortexPlusCharacterSheet from '@/components/CortexPlusCharacterSheet'
export default {
  name: 'CortexView',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App - Cortex'
    }
  },
  components: { CortexPlusCharacterSheet }
}
</script>

<style scoped>
</style>
